import { AutocompleteOption } from '../models/autocompleteOption';

export function getOptions(
  itemsArray: { id: string; name: string }[]
): AutocompleteOption[] {
  return itemsArray.map((item) => {
    return { label: item.name, id: item.id };
  });
}

export function getOptionsNameOnly(
  itemsArray: { name: string }[]
): AutocompleteOption[] {
  return itemsArray.map((item) => {
    return { label: item.name, id: item.name };
  });
}

export function generateUserWithIdLabel(name: string, id: string): string {
  return `${name} (${id})`;
}

export function generateUserLabel(name: string, id: string, type: string): string {
  return `${name} (${id}) - ${type}`;
}
